<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="8">
          <v-text-field
            dense
            outlined
            v-model="domain"
            label="Domain"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="4">
          <v-btn
            color="primary"
            @click="queryDomain"
          >Query</v-btn>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12">
      <v-row dense align="center" v-show="showPage">
        <v-col cols="12">
          <v-row>
            <v-col cols="3">
              <h3>{{ form.domain }}</h3>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="3">
              <h5>Status:<br>{{ form.status_name }}</h5>
            </v-col>
            <v-col cols="3">
              <h5>Registration Date:<br>{{ form.provision_date }}</h5>
            </v-col>
            <v-col cols="3">
              <h5>Expiry Date:<br>{{ form.expiry_date }}</h5>
            </v-col>
            <v-col cols="3">
            </v-col>
          </v-row>
          <v-form ref="updateNsForm">
            <v-row dense>
              <v-col cols="3">
                <v-text-field
                  label="NS1*"
                  v-model="form.ns1"
                  :rules="[rules.required, rules.nameserver]"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="NS2*"
                  v-model="form.ns2"
                  :rules="[rules.required, rules.nameserver]"></v-text-field>
              </v-col>
            </v-row>
            <v-row dense align="center">
              <v-col cols="3">
                <v-text-field
                  label="NS3"
                  v-model="form.ns3"
                  :rules="[rules.nameserver]"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="NS4"
                  v-model="form.ns4"
                  :rules="[rules.nameserver]"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field
                  label="NS5"
                  v-model="form.ns5"
                  :rules="[rules.nameserver]"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="3">
              </v-col>
            </v-row>
          </v-form>
          <v-row dense>
            <v-col cols="6">
              <v-form>
                <h5>Registrant Contact</h5>
                <profile
                  v-show="profile === 1"
                  ref="registrantProfileComp"
                  :setNewProfile="registrant"
                ></profile>
                <profile-sg
                  disable-uen-lookup
                  v-show="profile === 2"
                  ref="registrantProfileCompSg"
                  :setNewProfile="registrant"
                ></profile-sg>
                <profile-au
                  v-show="profile === 3"
                  ref="registrantProfileCompAu"
                  :setNewProfile="registrant"
                ></profile-au>
                <v-row dense>
                  <v-col cols="12">
                    <v-btn
                      color="primary"
                      :loading="updateRegistrantLoading"
                      @click="updateRegistrant"
                    >Update</v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Profile from '../../components/Profile.vue';
import ProfileSg from '../../components/ProfileSg.vue';
import ProfileAu from '../../components/ProfileAu.vue';

export default {
  name: 'UpdateDbDomainContact',
  components: {
    Profile,
    ProfileSg,
    ProfileAu,
  },
  created() {
    this.$api.get('admin/manage/domain-product/list').then((response) => {
      this.orderableProducts = response.data;
    });
  },
  data() {
    return {
      profile: 1,
      profileContact: this.$refs.registrantProfileComp,
      domain: '',
      id: null,
      showPage: false,
      epp: null,
      form: {
        domain: '',
        product_id: null,
        product_term: null,
        status_name: '',
        tld: null,
        auto_renew: true,
        locked: true,
        ns1: '',
        ns2: '',
        ns3: '',
        ns4: '',
        ns5: '',
        provision_date: '',
        expiry_date: '',
        registrant: {},
        admin: {},
        tech: {},
        billing: {},
      },
      childNss: [],
      addChildNss: [],
      deleteChildNss: [],
      updateChildNss: [],
      defaultContact: null,
      registrant: null,
      admin: null,
      tech: null,
      billing: null,
      domainErr: null,
      tld_list: [],
      tldPriceList: [],
      terms: [],
      checkDomainLoading: false,
      checkDomainInvalid: true,
      checkoutProcessing: false,
      checkoutDisabled: false,
      showPriceTable: false,
      showRegistrationForm: false,
      eppLoading: false,
      autoRenewLoading: false,
      lockLoading: false,
      updateNsLoading: false,
      updateRegistrantLoading: false,
      updateAdminLoading: false,
      updateTechLoading: false,
      updateBillingLoading: false,
      updateChildNsLoading: false,
      renewDialog: false,
      renewLoading: false,
      renewCheckoutLoading: false,
      renewalTerms: [],
      renewalTerm: null,
      successMessage:
        'We are registering your domain now. '
        + 'An email will be sent to you when your service is ready.',
      valid: false,
      rules: {
        required: (value) => !!value || 'This field is required.',
        isNumeric: (value) => this.$underscore.isFinite(value) || 'This field must be numeric.',
        domain: (value) => (/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?/i).test(value) || 'This field must be valid domain name.',
      },
      orderableProducts: [],
      addonData: null,
      serviceTermId: null,
      parentProductTerms: [],
      addonRegistrationComponentKey: 1,
      totalAddon: 0,
      buying: false,
      service: null,
      showServiceRenewDialog: false,
      renewServiceId: null,
      showServiceUpgradeDialog: false,
      upgradeServiceId: null,
      showServiceCancelDialog: false,
      cancelServiceId: null,
      cancelDialog: false,
      cancelLoading: false,
      cancelled: false,
    };
  },
  methods: {
    queryDomain() {
      this.$api.post('admin/service/query-domain', {
        domain: this.domain,
        no_restrict: 1,
      })
        .then((response) => {
          if (parseInt(response.data.id, 10) !== 0) {
            this.id = response.data.id;
            this.$set(this.form, 'domain', this.domain);
          } else {
            this.$store.dispatch('addAlert', {
              id: Date.now(),
              type: 'error',
              message: 'Domain not found.',
            });
          }
        });
    },
    reloadDomain() {
      this.$api.get(`admin/manage/domain/${this.id}?with_addon_info=1`).then((response) => {
        const domainData = response.data;
        this.serviceTermId = this.$gceCommon.getTermIdByTermMonth(domainData.service_month_term);
        this.service = domainData;
        this.form.product_id = domainData.product_id;
        this.form.provision_date = domainData.provision_date;
        this.form.status_name = domainData.service_status_name;
        this.form.expiry_date = domainData.expiry_date;
        this.form.auto_renew = domainData.auto_renew === 1;
        this.form.locked = domainData.domain_config.service_configuration.locked === 1;
        this.form.ns1 = domainData.domain_config.service_configuration.ns1;
        this.form.ns2 = domainData.domain_config.service_configuration.ns2;
        this.form.ns3 = domainData.domain_config.service_configuration.ns3;
        this.form.ns4 = domainData.domain_config.service_configuration.ns4;
        this.form.ns5 = domainData.domain_config.service_configuration.ns5;
        this.$set(this, 'registrant', domainData.domain_config.service_configuration.registrant);
        this.$set(this, 'admin', domainData.domain_config.service_configuration.admin);
        this.$set(this, 'tech', domainData.domain_config.service_configuration.tech);
        this.$set(this, 'billing', domainData.domain_config.service_configuration.billing);
        this.$set(this, 'addChildNss', []);
        this.$set(this, 'deleteChildNss', []);
        this.$set(this, 'childNss', domainData.domain_config.service_configuration.child_nameservers);
        this.showPage = true;
      });
    },
    updateRegistrant() {
      this.updateRegistrantLoading = true;
      const postUrl = `admin/service/domain/${this.id}/update-db-registrant-contact`;
      this.$api.post(postUrl,
        this.profileContact.getProfileData()).then(() => {
        this.$store.dispatch('addAlert', {
          id: Date.now(),
          type: 'success',
          message: 'Registrant contact is updated successfully.',
        });
      }).finally(() => {
        this.updateRegistrantLoading = false;
      });
    },
  },
  watch: {
    'form.domain': {
      handler(domain) {
        if (domain.indexOf('.sg') > 0) {
          this.profile = 2;
          this.profileContact = this.$refs.registrantProfileCompSg;
        } else if (domain.indexOf('.au') > 0) {
          this.profile = 3;
          this.profileContact = this.$refs.registrantProfileCompAu;
        } else {
          this.profile = 1;
          this.profileContact = this.$refs.registrantProfileComp;
        }
        this.reloadDomain();
      },
    },
  },
};
</script>

<style scoped>

</style>
